import { type AggResponse } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';

import type { KnowledgeDiscoveryIntentDetectionResponse } from './types';

/**
 * In-memory cache for intent detection results.
 * Cache key format: "siteId:orgId:query:experience[:model]".
 */
export const intentDetectionCache: {
	get: (key: string) => Promise<AggResponse<KnowledgeDiscoveryIntentDetectionResponse>> | undefined;
	set: (
		key: string,
		result: Promise<AggResponse<KnowledgeDiscoveryIntentDetectionResponse>>,
	) => void;
	has: (key: string) => boolean;
	clear: (key?: string) => void;
	inMemoryDecorator: (
		key: string,
		supplier: () => Promise<AggResponse<KnowledgeDiscoveryIntentDetectionResponse>>,
		expireWhen?:
			| ((result: AggResponse<KnowledgeDiscoveryIntentDetectionResponse>) => boolean)
			| undefined,
	) => Promise<AggResponse<KnowledgeDiscoveryIntentDetectionResponse>>;
} = inMemoryCache<AggResponse<KnowledgeDiscoveryIntentDetectionResponse>>();
